import { Link } from "react-router-dom";
import { useT, usePageTitle, Trans } from "@/i18n/LanguageContext";

export default function NotFound() {
  const t = useT();
  usePageTitle(t("meta.title.notFound"));
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 text-center">
      <div>
        <p className="overline">{t("nf.code")}</p>
        <h1 className="font-serif text-5xl md:text-6xl mt-4">
          <Trans tKey="nf.title" />
        </h1>
        <p className="text-melilux-cream/60 mt-6 max-w-md mx-auto">{t("nf.lead")}</p>
        <div className="mt-10 flex gap-4 justify-center">
          <Link
            to="/"
            className="bg-melilux-gold text-melilux-bg px-7 py-3 text-xs uppercase tracking-[0.28em] hover:bg-melilux-goldBright transition-colors"
            data-testid="nf-home"
          >
            {t("nf.home")}
          </Link>
          <Link
            to="/collections"
            className="border border-white/20 text-melilux-cream px-7 py-3 text-xs uppercase tracking-[0.28em] hover:border-melilux-gold hover:text-melilux-gold transition-colors"
            data-testid="nf-collections"
          >
            {t("nf.coll")}
          </Link>
        </div>
      </div>
    </div>
  );
}
